import script from "./SmsLoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsLoginForm.vue?vue&type=script&setup=true&lang=js"

import "./SmsLoginForm.vue?vue&type=style&index=0&id=bc1a6a28&scoped=true&lang=css"
import "./SmsLoginForm.vue?vue&type=style&index=1&id=bc1a6a28&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc1a6a28"]])

export default __exports__